// import { useEffect, useState, useCallback, useMemo } from "react";
// import { IPDCWelcomeMessage } from "../../../components";
// import {
//   Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
//   Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
//   FormControl, InputLabel, Select, IconButton, Table, TableBody, TableCell,
//   TableContainer, TableHead, TableRow, TablePagination, Dialog, DialogContent,
//   DialogTitle, CircularProgress, Chip, ToggleButton, ToggleButtonGroup
// } from "@mui/material";
// import {
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   WarningAmber as WarningIcon,
//   Receipt as ReceiptIcon,
//   AccountBalance as AccountBalanceIcon,
//   CompareArrows as CompareIcon,
//   AttachMoney as MoneyIcon,
//   Assessment as AssessmentIcon,
//   Business as BusinessIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   Download as DownloadIcon,
//   Close as CloseIcon,
//   BarChart as BarChartIcon,
//   PieChart as PieChartIcon,
//   ShowChart as ShowChartIcon,
//   Visibility as VisibilityIcon,
//   People as PeopleIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";

// // Helper function to normalize currency values
// const toNumber = (value) => {
//   if (typeof value === 'number' && !isNaN(value)) return value;
//   if (typeof value === 'string') {
//     const num = parseFloat(value);
//     return isNaN(num) ? 0 : num;
//   }
//   return 0;
// };

// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd") return "usd";
//   if (mode === "birr" || mode === "etb") return "birr";
//   return mode;
// };

// const formatNumber = (number) => {
//   const num = toNumber(number);
//   if (num === 0) return "0";
//   return new Intl.NumberFormat('en-US').format(num);
// };

// const formatCurrency = (amount, paymentMode) => {
//   const formatted = formatNumber(amount);
//   const mode = normalizeCurrency(paymentMode);
//   if (mode === "usd") return `$${formatted}`;
//   return `${formatted} ETB`;
// };

// const formatCurrencyUSD = (amount) => {
//   return `$${formatNumber(amount)}`;
// };

// const formatCurrencyETB = (amount) => {
//   return `${formatNumber(amount)} ETB`;
// };

// const formatPercentage = (value) => {
//   const num = toNumber(value);
//   if (num === 0) return "0%";
//   return `${num.toFixed(1)}%`;
// };

// const formatDate = (date) => {
//   if (!date) return "N/A";
//   try {
//     return format(new Date(date), 'dd/MM/yyyy');
//   } catch {
//     return "Invalid Date";
//   }
// };

// // Progress Bar Component - Smaller
// const ProgressBarCell = ({ value, label, color }) => {
//   const percentage = Math.min(100, Math.max(0, toNumber(value)));
//   const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
  
//   return (
//     <Box sx={{ minWidth: 80 }}>
//       <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
//         <Box>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//             <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
//               {formatPercentage(percentage)}
//             </Typography>
//           </Box>
//           <LinearProgress
//             variant="determinate"
//             value={percentage}
//             sx={{
//               height: 5,
//               borderRadius: 2.5,
//               backgroundColor: '#e0e0e0',
//               '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
//             }}
//           />
//         </Box>
//       </Tooltip>
//     </Box>
//   );
// };

// // Invoice Status Tracker Component - Smaller
// const InvoiceStatusTracker = ({ revenueData, arrearsData }) => {
//   const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const [activeCurrency, setActiveCurrency] = useState('usd');
  
//   // Calculate USD totals
//   const totalInvoicedUSD = revenueData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.amount || 0), 0) %100;
 
//   const totalOutstandingUSD = arrearsData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0) % 100;
  
//   const totalCollectedUSD = Math.max(0, Math.abs(totalInvoicedUSD + totalOutstandingUSD));
//   const paidPercentageUSD = totalInvoicedUSD > 0 ? (totalInvoicedUSD /  totalCollectedUSD) * 100 : 0;

//   console.log(totalInvoicedUSD)
//   console.log(totalOutstandingUSD)

//   const outstandingPercentageUSD = totalInvoicedUSD > 0 ? (totalOutstandingUSD / (totalOutstandingUSD + Math.abs(totalInvoicedUSD))) * 100 : 0;
  
//   // Calculate ETB totals
//   const totalInvoicedETB = revenueData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.amount || 0), 0);
  
//   const totalOutstandingETB = arrearsData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  
//   const totalCollectedETB = Math.max(0, Math.abs(totalInvoicedETB - totalOutstandingETB));
//   const paidPercentageETB = totalInvoicedETB > 0 ? (totalCollectedETB / totalInvoicedETB) * 100 : 0;
//   const outstandingPercentageETB = totalInvoicedETB > 0 ? (totalOutstandingETB / totalInvoicedETB) * 100 : 0;
  
//   // Group revenue by month for trend
//   const monthlyRevenueUSD = months.map((_, idx) => {
//     const monthNum = String(idx + 1).padStart(2, '0');
//     return revenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd" && item.month === monthNum)
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
//   });
  
//   const monthlyRevenueETB = months.map((_, idx) => {
//     const monthNum = String(idx + 1).padStart(2, '0');
//     return revenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr" && item.month === monthNum)
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
//   });
  
//   const monthlyArrearsUSD = months.map((_, idx) => {
//     const monthNum = String(idx + 1).padStart(2, '0');
//     return arrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd" && item.month === monthNum)
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//   });
  
//   const monthlyArrearsETB = months.map((_, idx) => {
//     const monthNum = String(idx + 1).padStart(2, '0');
//     return arrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr" && item.month === monthNum)
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//   });
  
//   const maxValueUSD = Math.max(...monthlyRevenueUSD, ...monthlyArrearsUSD, 1);
//   const maxValueETB = Math.max(...monthlyRevenueETB, ...monthlyArrearsETB, 1);
  
//   const chartHeight = 200; // Reduced from 250
//   const chartWidth = 400; // Reduced from 480
//   const padding = { top: 25, right: 35, bottom: 35, left: 50 };
  
//   // Donut Chart Component - Smaller
//   const DonutChart = ({ title, collected, outstanding, total, collectedPercent, outstandingPercent, currencySymbol, bgColor }) => {
//     const circumference = 2 * Math.PI * 40;
//     const collectedDash = (collectedPercent / 100) * circumference;
//     const outstandingDash = (outstandingPercent / 100) * circumference;
    
//     return (
//       <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//         <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 0.5, color: bgColor, fontSize: '0.7rem' }}>
//           {title}
//         </Typography>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, flexDirection: 'column' }}>
//           <Box sx={{ position: 'relative', width: 100, height: 100 }}>
//             <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}>
//               <circle cx="50" cy="50" r="40" fill="#f5f5f5" stroke="#e0e0e0" strokeWidth="1" />
//               <circle 
//                 cx="50" cy="50" r="40" 
//                 fill="none" 
//                 stroke="#4caf50" 
//                 strokeWidth="12" 
//                 strokeDasharray={`${collectedDash} ${circumference}`}
//                 strokeDashoffset="0"
//                 strokeLinecap="round"
//               />
//               <circle 
//                 cx="50" cy="50" r="40" 
//                 fill="none" 
//                 stroke="#d32f2f" 
//                 strokeWidth="12" 
//                 strokeDasharray={`${outstandingDash} ${circumference}`}
//                 strokeDashoffset={`-${collectedDash}`}
//                 strokeLinecap="round"
//               />
//               <circle cx="50" cy="50" r="30" fill="white" />
//               <text x="50" y="46" textAnchor="middle" style={{ fontSize: '10px' }} fill="#333">Total</text>
//               <text x="50" y="58" textAnchor="middle" style={{ fontSize: '10px' }} fill="#1976d2">
//                 {currencySymbol}{total >= 1000 ? formatNumber(total / 1000) + 'K' : formatNumber(total)}
//               </text>
//             </svg>
//           </Box>
          
//           <Box sx={{ minWidth: 120 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: '#4caf50', borderRadius: 1 }} />
//                 <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mr: 1}}>Collected :  </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
//                 <Typography variant="body2" fontWeight="bold" sx={{ color: '#4caf50', fontSize: '0.8rem' }}>
//                   {collectedPercent.toFixed(1)}%
//                 </Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>
//                   ({currencySymbol}{formatNumber(collected)})
//                 </Typography>
//               </Box>
//             </Box>
            
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: '#d32f2f', borderRadius: 1 }} />
//                 <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mr: 1 }}>
//                   Outstanding :  
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
//                 <Typography variant="body2" fontWeight="bold" sx={{ color: '#d32f2f', fontSize: '0.8rem' }}>
//                   {outstandingPercent.toFixed(1)}%
//                 </Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>
//                   ({currencySymbol}{formatNumber(outstanding)})
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     );
//   };
  
//   // Monthly Trend Chart Component - Smaller
//   const MonthlyTrendChart = ({ revenueData, arrearsData, maxValue, currencySymbol, lineColor1, lineColor2 }) => (
//     <Box sx={{ width: '100%' }}>
//       <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`}>
//         {[0, 25, 50, 75, 100].map((percent, idx) => {
//           const value = (maxValue * percent) / 100;
//           const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//           return (
//             <g key={idx}>
//               <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="3" />
//               <text x={padding.left - 6} y={y} textAnchor="end" fontSize="7" fill="#666">
//                 {currencySymbol}{value >= 1000 ? formatNumber(value / 1000) + 'K' : formatNumber(value)}
//               </text>
//             </g>
//           );
//         })}
        
//         <polyline points={revenueData.map((value, idx) => {
//           const x = padding.left + (idx / (Math.max(revenueData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
//           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//           return `${x},${y}`;
//         }).join(' ')} fill="none" stroke={lineColor1} strokeWidth="2" />
        
//         <polyline points={arrearsData.map((value, idx) => {
//           const x = padding.left + (idx / (Math.max(arrearsData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
//           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//           return `${x},${y}`;
//         }).join(' ')} fill="none" stroke={lineColor2} strokeWidth="2" />
        
//         {revenueData.map((value, idx) => {
//           const x = padding.left + (idx / (Math.max(revenueData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
//           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//           return <circle key={`rev-${idx}`} cx={x} cy={y} r="3" fill={lineColor1} stroke="white" strokeWidth="1.5" />;
//         })}
        
//         {arrearsData.map((value, idx) => {
//           const x = padding.left + (idx / (Math.max(arrearsData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
//           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//           return <circle key={`arr-${idx}`} cx={x} cy={y} r="3" fill={lineColor2} stroke="white" strokeWidth="1.5" />;
//         })}
        
//         {months.map((month, idx) => {
//           const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
//           return <text key={idx} x={x} y={chartHeight - padding.bottom + 14} textAnchor="middle" fontSize="7" fontWeight="500">{month}</text>;
//         })}
        
//         <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
//         <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
//       </svg>
      
//       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 1 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Box sx={{ width: 20, height: 2, bgcolor: lineColor1 }} />
//           <Box sx={{ width: 6, height: 6, bgcolor: lineColor1, borderRadius: '50%' }} />
//           <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>Invoiced</Typography>
//         </Box>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Box sx={{ width: 20, height: 2, bgcolor: lineColor2 }} />
//           <Box sx={{ width: 6, height: 6, bgcolor: lineColor2, borderRadius: '50%' }} />
//           <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>Outstanding</Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
  
//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
//         <ToggleButtonGroup
//           value={activeCurrency}
//           exclusive
//           onChange={(e, val) => val && setActiveCurrency(val)}
//           size="small"
//           sx={{
//             '& .MuiToggleButton-root': {
//               borderColor: '#1976d2',
//               color: '#1976d2',
//               textTransform: 'none',
//               px: 2,
//               py: 0.5,
//               fontSize: '0.7rem',
//               '&.Mui-selected': {
//                 backgroundColor: '#1976d2',
//                 color: 'white',
//               }
//             }
//           }}
//         >
//           <ToggleButton value="usd">USD</ToggleButton>
//           <ToggleButton value="etb">ETB</ToggleButton>
//         </ToggleButtonGroup>
//       </Box>
      
//       {/* USD View */}
//       {activeCurrency === 'usd' && (
//         <Box>
//           <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 1.5, overflowX: 'auto', justifyContent: 'center', alignItems: 'center' }}>
//             <DonutChart 
//               title="Invoice Status (USD)"
//               collected={totalCollectedUSD}
//               outstanding={totalOutstandingUSD}
//               total={totalInvoicedUSD}
//               collectedPercent={paidPercentageUSD}
//               outstandingPercent={outstandingPercentageUSD}
//               currencySymbol="$"
//               bgColor="#1976d2"
//             />
            
//             <Box sx={{ width: 1.5, height: 200, bgcolor: '#e0e0e0', alignSelf: 'center' }} />
            
//             <Box sx={{ flex: 1, minWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 1, color: '#1976d2', fontSize: '0.7rem' }}>
//                 Monthly USD Trend
//               </Typography>
//               <MonthlyTrendChart 
//                 revenueData={monthlyRevenueUSD}
//                 arrearsData={monthlyArrearsUSD}
//                 maxValue={maxValueUSD}
//                 currencySymbol="$"
//                 lineColor1="#1976d2"
//                 lineColor2="#d32f2f"
//               />
//             </Box>
//           </Box>
          
//           <Box sx={{ mt: 1.5, p: 1, bgcolor: '#f5f5f5', borderRadius: 1.5, display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 1 }}>
//             <Box sx={{ textAlign: 'center' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
//               Invoiced:
//             </Typography>
//             <Typography variant="body2" fontWeight="bold" color="#1976d2" sx={{ fontSize: '0.8rem' }}>
//               ${formatNumber(totalInvoicedUSD)}
//             </Typography>
//           </Box>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
//               Collected: 
//             </Typography>
//             <Typography variant="body2" fontWeight="bold" color="#4caf50" sx={{ fontSize: '0.8rem' }}>
//               ${formatNumber(totalCollectedUSD)}
//             </Typography>
//           </Box>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
//               Outstanding:
//             </Typography>
//             <Typography variant="body2" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '0.8rem' }}>
//               ${formatNumber(totalOutstandingUSD)}
//             </Typography>
//           </Box>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
//               Collection Rate
//             </Typography>
//             <Typography variant="body2" fontWeight="bold" color="#1976d2" sx={{ fontSize: '0.8rem' }}>
//               {paidPercentageUSD.toFixed(1)}%
//             </Typography>
//           </Box>
//             </Box>
//           </Box>
//         </Box>
//       )}
      
//       {/* ETB View - Similar smaller sizing */}
//       {activeCurrency === 'etb' && (
//         <Box>
//           <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 1.5, overflowX: 'auto', justifyContent: 'center', alignItems: 'center' }}>
//             <DonutChart 
//               title="Invoice Status (ETB)"
//               collected={totalCollectedETB}
//               outstanding={totalOutstandingETB}
//               total={totalInvoicedETB}
//               collectedPercent={paidPercentageETB}
//               outstandingPercent={outstandingPercentageETB}
//               currencySymbol=""
//               bgColor="#2e7d32"
//             />
            
//             <Box sx={{ width: 1.5, height: 200, bgcolor: '#e0e0e0', alignSelf: 'center' }} />
            
//             <Box sx={{ flex: 1, minWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 1, color: '#2e7d32', fontSize: '0.7rem' }}>
//                 Monthly ETB Trend
//               </Typography>
//               <MonthlyTrendChart 
//                 revenueData={monthlyRevenueETB}
//                 arrearsData={monthlyArrearsETB}
//                 maxValue={maxValueETB}
//                 currencySymbol=""
//                 lineColor1="#2e7d32"
//                 lineColor2="#d32f2f"
//               />
//             </Box>
//           </Box>
          
//           <Box sx={{ mt: 1.5, p: 1, bgcolor: '#f5f5f5', borderRadius: 1.5, display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 1 }}>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Invoiced</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '0.7rem' }}>{formatNumber(totalInvoicedETB)} ETB</Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Collected</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#4caf50" sx={{ fontSize: '0.7rem' }}>{formatNumber(totalCollectedETB)} ETB</Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Outstanding</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '0.7rem' }}>{formatNumber(totalOutstandingETB)} ETB</Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Collection Rate</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '0.7rem' }}>{paidPercentageETB.toFixed(1)}%</Typography>
//             </Box>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // Top 5 Customers Pie Chart - Smaller
// const TopCustomersPieChart = ({ data, title, subtitle, currencySymbol }) => {
//   const total = Object.values(data).reduce((sum, val) => sum + toNumber(val), 0);
//   const colors = ['#1976d2', '#2196f3', '#42a5f5', '#64b5f6', '#90caf9', '#e0e0e0'];
//   const items = Object.keys(data);
//   const displayItems = items.slice(0, 5);
//   const top5Total = displayItems.reduce((sum, key) => sum + toNumber(data[key]), 0);
//   const otherValue = total - top5Total;
  
//   let startAngle = 0;
//   const centerX = 60, centerY = 60, radius = 50;
//   const svgSize = 120;
  
//   return (
//     <Box sx={{ textAlign: 'center' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5, fontSize: '0.7rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {[...displayItems, ...(otherValue > 0 ? ['Others'] : [])].map((key, idx) => {
//               const value = key === 'Others' ? otherValue : toNumber(data[key]);
//               const percentage = total > 0 ? (value / total) * 100 : 0;
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
              
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
              
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
              
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
//               const slice = <path key={idx} d={pathData} fill={colors[idx % colors.length]} stroke="white" strokeWidth="1" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//             <circle cx={centerX} cy={centerY} r="22" fill="white" />
//           </svg>
//         </Box>
//         <Box sx={{ minWidth: 110 }}>
//           {displayItems.map((customer, idx) => {
//             const value = toNumber(data[customer]);
//             return (
//               <Box key={customer} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: colors[idx], borderRadius: 1 }} />
//                 <Typography variant="caption" sx={{ fontSize: '0.6rem', flex: 1 }}>{customer.length > 12 ? customer.substring(0, 10) + '...' : customer}</Typography>
//                 <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{currencySymbol}{formatNumber(value)}</Typography>
//               </Box>
//             );
//           })}
//           {otherValue > 0 && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.3 }}>
//               <Box sx={{ width: 8, height: 8, bgcolor: '#e0e0e0', borderRadius: 1 }} />
//               <Typography variant="caption" sx={{ fontSize: '0.6rem', flex: 1 }}>Others</Typography>
//               <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{currencySymbol}{formatNumber(otherValue)}</Typography>
//             </Box>
//           )}
//         </Box>
//       </Box>
//       <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1, fontSize: '0.55rem' }}>{subtitle}</Typography>
//     </Box>
//   );
// };

// // Horizontal Bar Chart for Aging Buckets - Smaller
// const AgingBucketsChart = ({ arrearsData }) => {
//   const buckets = ['0-30 days', '31-60 days', '61-90 days', '90+ days'];
  
//   const amounts = buckets.map(bucket => {
//     if (bucket === '0-30 days') {
//       return arrearsData.filter(item => item.overdue_days > 0 && item.overdue_days <= 30)
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//     } else if (bucket === '31-60 days') {
//       return arrearsData.filter(item => item.overdue_days > 30 && item.overdue_days <= 60)
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//     } else if (bucket === '61-90 days') {
//       return arrearsData.filter(item => item.overdue_days > 60 && item.overdue_days <= 90)
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//     } else {
//       return arrearsData.filter(item => item.overdue_days > 90)
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//     }
//   });
  
//   const maxAmount = Math.max(...amounts, 1);
  
//   return (
//     <Box sx={{ p: 1 }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2, fontSize: '0.7rem' }}>Aging Buckets by Overdue Amount</Typography>
//       {buckets.map((bucket, idx) => {
//         const widthPercentage = (amounts[idx] / maxAmount) * 100;
//         return (
//           <Box key={idx} sx={{ mb: 1.5 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>{bucket}</Typography>
//               <Typography variant="caption" sx={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '0.8rem' }}>${formatNumber(amounts[idx])}</Typography>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={widthPercentage}
//               sx={{
//                 height: 20,
//                 borderRadius: 2,
//                 backgroundColor: '#f5f5f5',
//                 '& .MuiLinearProgress-bar': {
//                   backgroundColor: idx === 0 ? '#ffc107' : idx === 1 ? '#ff9800' : idx === 2 ? '#f44336' : '#d32f2f',
//                   borderRadius: 2,
//                 }
//               }}
//             />
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// // Top 5 Customers Bar Chart - Smaller
// const TopCustomersBarChart = ({ data, title, color, currencySymbol }) => {
//   const customers = Object.keys(data);
//   const maxValue = Math.max(...Object.values(data).map(v => toNumber(v)), 0);
  
//   return (
//     <Box sx={{ p: 1 }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.9rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.8, minHeight: 200, justifyContent: 'center', flexWrap: 'wrap' }}>
//         {customers.map((customer) => {
//           const value = toNumber(data[customer]);
//           const height = maxValue > 0 ? (value / maxValue) * 140 : 0;
//           return (
//             <Tooltip key={customer} title={`${customer}: ${currencySymbol}${formatNumber(value)}`} arrow>
//               <Box sx={{ textAlign: 'center', minWidth: 50 }}>
//                 <Box sx={{ height: height, width: '35px', bgcolor: color, borderRadius: '3px 3px 0 0', margin: '0 auto', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8, transform: 'translateY(-3px)' } }} />
//                 <Typography variant="caption" sx={{ mt: 0.3, display: 'block', fontWeight: 'bold', fontSize: '0.8rem' }}>{customer.length > 10 ? customer.substring(0, 8) + '...' : customer}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>{currencySymbol}{formatNumber(value)}</Typography>
//               </Box>
//             </Tooltip>
//           );
//         })}
//       </Box>
//     </Box>
//   );
// };

// // Overdue Balance by Collector Pie Chart - Smaller
// const CollectorPieChart = ({ arrearsData }) => {
//   const collectorMap = {};
  
//   arrearsData.forEach(item => {
//     const collector = item.collector_name || item.collector || 'Unassigned';
//     collectorMap[collector] = (collectorMap[collector] || 0) + (item.outstanding || 0);
//   });
  
//   const collectors = Object.keys(collectorMap);
//   const amounts = Object.values(collectorMap);
//   const total = amounts.reduce((sum, val) => sum + val, 0);
//   const percentages = amounts.map(amt => total > 0 ? (amt / total) * 100 : 0);
//   const colors = ['#1976d2', '#42a5f5', '#64b5f6', '#90caf9', '#bbdefb'];
  
//   let startAngle = 0;
//   const centerX = 60, centerY = 60, radius = 50;
//   const svgSize = 120;
  
//   if (collectors.length === 0) {
//     return (
//       <Box sx={{ textAlign: 'center', p: 2 }}>
//         <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.6rem' }}>No collector data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ textAlign: 'center', p: 1 }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, fontSize: '0.7rem' }}>Overdue Balance by Collector</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {collectors.map((collector, idx) => {
//               const percentage = percentages[idx];
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
              
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
              
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
              
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
//               const slice = <path key={idx} d={pathData} fill={colors[idx % colors.length]} stroke="white" strokeWidth="1" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//             <circle cx={centerX} cy={centerY} r="22" fill="white" />
//           </svg>
//         </Box>
//         <Box>
//           {collectors.map((collector, idx) => (
//             <Box key={collector} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
//               <Box sx={{ width: 8, height: 8, bgcolor: colors[idx % colors.length], borderRadius: 1 }} />
//               <Typography variant="body2" sx={{ fontSize: '0.6rem', minWidth: 70 }}>{collector}</Typography>
//               <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{percentages[idx].toFixed(0)}%</Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default function AccountsReceivableDashboard() {
//   // State Management
//   const [loading, setLoading] = useState(false);
//   const [revenueData, setRevenueData] = useState([]);
//   const [arrearsData, setArrearsData] = useState([]);
  
//   // Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedCustomer, setSelectedCustomer] = useState("all");
//   const [selectedCollector, setSelectedCollector] = useState("all");
//   const [selectedCurrency, setSelectedCurrency] = useState("all");
  
//   // Pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
  
//   // Derived Data from API
//   const revenueUSD = useMemo(() => {
//     return revenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
//   }, [revenueData]);
  
//   const revenueETB = useMemo(() => {
//     return revenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
//   }, [revenueData]);
  
//   const arrearsUSD = useMemo(() => {
//     return arrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//   }, [arrearsData]);
  
//   const arrearsETB = useMemo(() => {
//     return arrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
//   }, [arrearsData]);
  
//   const percentOverdue = useMemo(() => {
//     const totalRevenue = revenueUSD + revenueETB;
//     const totalArrears = arrearsUSD + arrearsETB;
//     return totalRevenue > 0 ? (totalArrears / totalRevenue) * 100 : 0;
//   }, [revenueUSD, revenueETB, arrearsUSD, arrearsETB]);
  
//   // Top 5 Customers (from Revenue data)
//   const topCustomersBySales = useMemo(() => {
//     const customerMap = {};
//     revenueData.forEach(item => {
//       const customer = item.company_name;
//       if (customer && customer !== "N/A") {
//         customerMap[customer] = (customerMap[customer] || 0) + (item.amount || 0);
//       }
//     });
//     const sorted = Object.entries(customerMap)
//       .sort((a, b) => b[1] - a[1])
//       .slice(0, 5);
//     return Object.fromEntries(sorted);
//   }, [revenueData]);
  
//   // Top 5 Customers by Receivables
//   const topCustomersByReceivables = useMemo(() => {
//     const customerMap = {};
//     revenueData
//       .filter(item => item.payment_status !== "Completed")
//       .forEach(item => {
//         const customer = item.company_name;
//         if (customer && customer !== "N/A") {
//           customerMap[customer] = (customerMap[customer] || 0) + (item.amount || 0);
//         }
//       });
//     const sorted = Object.entries(customerMap)
//       .sort((a, b) => b[1] - a[1])
//       .slice(0, 5);
//     return Object.fromEntries(sorted);
//   }, [revenueData]);
  
//   // Top 5 Customers by Overdue Receivables
//   const topCustomersByOverdue = useMemo(() => {
//     const customerMap = {};
//     arrearsData.forEach(item => {
//       const customer = item.company_name;
//       if (customer && customer !== "N/A") {
//         customerMap[customer] = (customerMap[customer] || 0) + (item.outstanding || 0);
//       }
//     });
//     const sorted = Object.entries(customerMap)
//       .sort((a, b) => b[1] - a[1])
//       .slice(0, 5);
//     return Object.fromEntries(sorted);
//   }, [arrearsData]);
  
//   // Customers and Collectors Lists
//   const customersList = useMemo(() => {
//     const customers = new Set();
//     revenueData.forEach(item => {
//       if (item.company_name && item.company_name !== "N/A") customers.add(item.company_name);
//     });
//     arrearsData.forEach(item => {
//       if (item.company_name && item.company_name !== "N/A") customers.add(item.company_name);
//     });
//     return Array.from(customers);
//   }, [revenueData, arrearsData]);
  
//   const collectorsList = useMemo(() => {
//     const collectors = new Set();
//     arrearsData.forEach(item => {
//       if (item.collector_name && item.collector_name !== "N/A") collectors.add(item.collector_name);
//       if (item.collector && item.collector !== "N/A") collectors.add(item.collector);
//     });
//     return Array.from(collectors);
//   }, [arrearsData]);
  
//   // Outstanding Invoices from Arrears data
//   const outstandingInvoices = useMemo(() => {
//     return arrearsData.map((item, index) => ({
//       id: item.agreement_id || `ARR-${index}`,
//       customer: item.company_name,
//       collector: item.collector_name || item.collector || "Unassigned",
//       date: item.due_date_formatted || formatDate(item.due_date),
//       dueDate: item.due_date_formatted || formatDate(item.due_date),
//       amount: item.outstanding || 0,
//       outstanding: item.outstanding || 0,
//       days: item.overdue_days || 0,
//       status: item.status || "Current",
//       payment_mode: item.payment_mode
//     }));
//   }, [arrearsData]);
  
//   // Filtered invoices based on search and filters
//   const filteredInvoices = useMemo(() => {
//     let filtered = [...outstandingInvoices];
    
//     if (searchTerm) {
//       filtered = filtered.filter(item =>
//         item.customer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.id?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (selectedCustomer !== "all") {
//       filtered = filtered.filter(item => item.customer === selectedCustomer);
//     }
    
//     if (selectedCollector !== "all") {
//       filtered = filtered.filter(item => item.collector === selectedCollector);
//     }
    
//     if (selectedCurrency !== "all") {
//       filtered = filtered.filter(item => normalizeCurrency(item.payment_mode) === selectedCurrency);
//     }
    
//     return filtered;
//   }, [outstandingInvoices, searchTerm, selectedCustomer, selectedCollector, selectedCurrency]);

//   // Fetch Revenue Data from API
//   useEffect(() => {
//     const fetchRevenue = async () => {
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
//         console.log("Revenue Response:", resultData);
        
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) {
//           dataArray = resultData;
//         } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
//           dataArray = resultData.data;
//         } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
//           dataArray = resultData.results;
//         } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
//           dataArray = resultData.items;
//         } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
//           dataArray = resultData.records;
//         } else if (resultData && typeof resultData === 'object') {
//           for (let key in resultData) {
//             if (Array.isArray(resultData[key])) {
//               dataArray = resultData[key];
//               console.log(`Found array in property: ${key}`);
//               break;
//             }
//           }
//         }
        
//         if (dataArray.length > 0) {
//           const formattedData = dataArray.map((item, index) => {
//             let revenueAmount = 0;
            
//             if (item.payment_amount !== undefined && item.payment_amount !== null) {
//               if (typeof item.payment_amount === 'number') {
//                 revenueAmount = item.payment_amount;
//               } else if (typeof item.payment_amount === 'string') {
//                 const cleaned = item.payment_amount.replace(/,/g, '');
//                 revenueAmount = parseFloat(cleaned);
//                 if (isNaN(revenueAmount)) revenueAmount = 0;
//               } else {
//                 revenueAmount = parseFloat(item.payment_amount);
//                 if (isNaN(revenueAmount)) revenueAmount = 0;
//               }
//             }
//             else if (item.amount !== undefined && item.amount !== null) {
//               revenueAmount = parseFloat(item.amount);
//               if (isNaN(revenueAmount)) revenueAmount = 0;
//             } else if (item.revenue !== undefined && item.revenue !== null) {
//               revenueAmount = parseFloat(item.revenue);
//               if (isNaN(revenueAmount)) revenueAmount = 0;
//             }
            
//             let paymentMode = "ETB";
//             if (item.payment_mode) {
//               paymentMode = item.payment_mode;
//             } else if (item.currency) {
//               paymentMode = item.currency;
//             }
            
//             let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
//             let month = item.month;
//             let year = item.year;
            
//             if (transactionDate && !month) {
//               try {
//                 const dateObj = new Date(transactionDate);
//                 if (!isNaN(dateObj.getTime())) {
//                   month = format(dateObj, 'MM');
//                   year = format(dateObj, 'yyyy');
//                 }
//               } catch (e) {
//                 console.warn("Date parsing error:", e);
//               }
//             }
            
//             return {
//               id: item.id || item.revenue_id || item.transaction_id || index,
//               transaction_id: item.transaction_id || item.id || `TRX-${index}`,
//               company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
//               park_name: item.park || item.park_name || item.location || "N/A",
//               payment_mode: paymentMode,
//               amount: revenueAmount,
//               formattedAmount: formatCurrency(revenueAmount, paymentMode),
//               transaction_date: transactionDate,
//               transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
//               revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
//               payment_status: item.payment_status || item.status || "Completed",
//               tenant_name: item.company_name || item.tenant_name || "N/A",
//               invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
//               description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
//               month: month || "01",
//               year: year || "2024",
//               upin: item.upin || "N/A",
//               contact_number: item.contact_number || item.phone || "N/A",
//               email: item.email || "N/A"
//             };
//           });
          
//           console.log("Formatted revenue data:", formattedData);
//           setRevenueData(formattedData);
//         } else {
//           console.log("No revenue data received");
//           setRevenueData([]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch revenue data:", error);
//         setRevenueData([]);
//       }
//     };
    
//     fetchRevenue();
//   }, []);

//   // Fetch Arrear Data from API
//   useEffect(() => {
//     const fetchArrear = async () => {
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
//         console.log("Arrear Response:", resultData);
        
//         if (resultData && Array.isArray(resultData)) {
//           const formattedData = resultData.map(item => {
//             const overdueDays = item.overdue_date || 0;
//             const outstandingAmount = parseFloat(item.outstanding) || 0;
//             const paymentMode = item.payment_mode || "ETB";
            
//             let year = "2024";
//             let month = "01";
//             if (item.due_date) {
//               try {
//                 const dateObj = new Date(item.due_date);
//                 if (!isNaN(dateObj.getTime())) {
//                   year = format(dateObj, 'yyyy');
//                   month = format(dateObj, 'MM');
//                 }
//               } catch (e) {}
//             }
            
//             return {
//               id: item.agreement_id,
//               agreement_id: item.agreement_id,
//               company_name: item.company_name || "N/A",
//               park_name: item.park || "N/A",
//               payment_mode: paymentMode,
//               outstanding: outstandingAmount,
//               formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
//               due_date: item.due_date,
//               due_date_formatted: formatDate(item.due_date),
//               overdue_days: overdueDays,
//               status: overdueDays >= 90 ? "Critical" : overdueDays >= 60 ? "Severe" : overdueDays >= 30 ? "Moderate" : overdueDays >= 1 ? "Mild" : "Current",
//               collector_name: item.collector_name || item.collector,
//               collector: item.collector || item.collector_name,
//               tenant_name: item.company_name || "N/A",
//               amount_due: outstandingAmount,
//               amount_paid: 0,
//               balance: outstandingAmount,
//               days_overdue: overdueDays,
//               description: `Arrears for ${item.company_name}`,
//               upin: item.upin || "N/A",
//               contact_number: item.contact_number || "N/A",
//               email: item.email || "N/A",
//               month: month,
//               year: year
//             };
//           });
          
//           console.log("Formatted arrears data:", formattedData);
//           setArrearsData(formattedData);
//         } else {
//           console.log("No arrears data received");
//           setArrearsData([]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch arrears data:", error);
//         setArrearsData([]);
//       }
//     };
    
//     fetchArrear();
//   }, []);

//   const resetFilters = () => {
//     setSearchTerm("");
//     setSelectedCustomer("all");
//     setSelectedCollector("all");
//     setSelectedCurrency("all");
//   };

//   const handleExportCSV = () => {
//     const headers = ['Invoice #', 'Customer', 'Collector', 'Due Date', 'Days Overdue', 'Amount', 'Status'];
//     const csvData = filteredInvoices.map(item => [
//       item.id,
//       item.customer,
//       item.collector,
//       item.dueDate,
//       item.days,
//       formatCurrency(item.amount, item.payment_mode),
//       item.status
//     ]);
    
//     const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `accounts_receivable_${format(new Date(), 'yyyyMMdd')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const getCurrentPageData = () => {
//     return filteredInvoices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//   };

//   const isLoading = revenueData.length === 0 && arrearsData.length === 0;

//   return (
//     <Container maxWidth="xl" sx={{ bgcolor: '#f4f9ff', width: '98%', mx: '1%', py: 1 }}>
//       <Grid container spacing={1.5}>
//       <Box sx={{ color: 'white', py: 2, px: 3 }}>
//         <Container maxWidth="xl">
//           <Box>
//             <Grid item xs={12} md={12}>
//               <IPDCWelcomeMessage messageTitle="Finance Department" />
//             </Grid>
//           </Box>
//         </Container>
//       </Box>
//         {/* Header */}
//         <Grid item xs={12}>
//           <Typography variant="h6" sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 0.5, fontSize: '1.1rem' }}>
//             Accounts Receivable Dashboard
//           </Typography>
//         </Grid>
        
//         {/* Summary Cards Row - Smaller */}
//         <Grid item xs={12}>
//           <Grid container spacing={1.5}>
//             <Grid item xs={12} sm={6} md={3}>
//               <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                   <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Revenue (USD)</Typography>
//                   <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 20 }} />
//                 </Box>
//                 <Typography variant="h6" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '1rem' }}>{formatCurrencyUSD(revenueUSD)}</Typography>
//                 <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Total Revenue in USD</Typography>
//                 <Divider sx={{ my: 0.5 }} />
//               </Card>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={3}>
//               <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                   <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Revenue (ETB)</Typography>
//                   <MoneyIcon sx={{ color: '#2e7d32', fontSize: 20 }} />
//                 </Box>
//                 <Typography variant="h6" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '1rem' }}>{formatCurrencyETB(revenueETB)}</Typography>
//                 <Typography variant="caption" color="textSecondary" sx={{ fontSize: '1.2rem' }}>Total revenue in ETB</Typography>
//                 <Divider sx={{ my: 0.5 }} />
//               </Card>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={3}>
//               <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                   <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Arrears (USD)</Typography>
//                   <WarningIcon sx={{ color: '#d32f2f', fontSize: 20 }} />
//                 </Box>
//                 <Typography variant="h6" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '1rem' }}>{formatCurrencyUSD(arrearsUSD)}</Typography>
//                 <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Outstanding in USD</Typography>
//                 <Divider sx={{ my: 0.5 }} />
//               </Card>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={3}>
//               <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                   <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Arrears (ETB)</Typography>
//                   <AccountBalanceIcon sx={{ color: '#d32f2f', fontSize: 20 }} />
//                 </Box>
//                 <Typography variant="h6" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '1rem' }}>{formatCurrencyETB(arrearsETB)}</Typography>
//                 <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Outstanding in ETB</Typography>
//                 <Divider sx={{ my: 0.5 }} />
//               </Card>
//             </Grid>
//           </Grid>
//         </Grid>
        
//         {/* Chart 1: Invoice Status Tracker - Smaller card */}
//         <Grid item xs={12}>
//           <Card sx={{ bgcolor: '#fafafa' }}>
//             <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Invoice Status Tracker</Typography>
//                 <BarChartIcon sx={{ color: '#666', fontSize: 18 }} />
//               </Box>
//               <Divider sx={{ mb: 1 }} />
//               <InvoiceStatusTracker revenueData={revenueData} arrearsData={arrearsData} />
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Chart 2: Aging Buckets */}
//         <Grid item xs={12} md={6}>
//           <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
//             <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Aging Buckets by Overdue Amount</Typography>
//                 <BarChartIcon sx={{ color: '#d32f2f', fontSize: 18 }} />
//               </Box>
//               <Divider sx={{ mb: 1 }} />
//               <AgingBucketsChart arrearsData={arrearsData} />
//             </CardContent>
//           </Card>
//         </Grid>
        
//         {/* Chart 3: Top 5 Customers by Overdue Receivables */}
//         <Grid item xs={12} md={6}>
//           <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
//             <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Top 5 Customers by Overdue</Typography>
//                 <WarningIcon sx={{ color: '#d32f2f', fontSize: 18 }} />
//               </Box>
//               <Divider sx={{ mb: 1 }} />
//               <TopCustomersBarChart 
//                 data={topCustomersByOverdue}
//                 title="Top 5 Customers by Overdue Receivables"
//                 color="#d32f2f"
//                 currencySymbol="$"
//               />
//             </CardContent>
//           </Card>
//         </Grid>
        
//         {/* Charts 4 & 5: Top Customers */}
//         {/* <Grid item xs={12}>
//           <Grid container spacing={1.5}>
//             <Grid item xs={12} md={6}>
//               <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
//                 <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
//                   <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2', fontSize: '0.75rem' }}>Top 5 Customers</Typography>
//                     <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 18 }} />
//                   </Box>
//                   <Divider sx={{ mb: 1 }} />
//                   <TopCustomersPieChart 
//                     data={topCustomersBySales}
//                     title="Top 5 Customers"
//                     subtitle="Top 5 customers contribution"
//                     currencySymbol="$"
//                   />
//                 </CardContent>
//               </Card>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
//                 <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
//                   <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2', fontSize: '0.75rem' }}>Top 5 Customers by Receivables</Typography>
//                     <AccountBalanceIcon sx={{ color: '#ff9800', fontSize: 18 }} />
//                   </Box>
//                   <Divider sx={{ mb: 1 }} />
//                   <TopCustomersPieChart 
//                     data={topCustomersByReceivables}
//                     title="Top 5 Customers by Receivables"
//                     subtitle="Top 5 customers receivables"
//                     currencySymbol="$"
//                   />
//                 </CardContent>
//               </Card>
//             </Grid>
//           </Grid>
//         </Grid> */}
//       </Grid>
      
//       {/* Details Dialog */}
//       <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between">
//             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Invoice Details</Typography>
//             <IconButton onClick={() => setOpenDetailsDialog(false)}><CloseIcon /></IconButton>
//           </Box>
//         </DialogTitle>
//         <Divider />
//         <DialogContent>
//           {selectedItem && (
//             <Box sx={{ mt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Invoice #:</Typography><Typography>{selectedItem.id}</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Customer:</Typography><Typography>{selectedItem.customer}</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Collector:</Typography><Typography>{selectedItem.collector}</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Due Date:</Typography><Typography>{selectedItem.dueDate}</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Days Overdue:</Typography><Typography>{selectedItem.days} days</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Outstanding Amount:</Typography><Typography sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{formatCurrency(selectedItem.amount, selectedItem.payment_mode)}</Typography></Grid>
//                 <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Status:</Typography><Chip label={selectedItem.status} size="small" color={selectedItem.status === 'Critical' ? 'error' : (selectedItem.status === 'Severe' ? 'warning' : 'info')} /></Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}><Button onClick={() => setOpenDetailsDialog(false)} variant="outlined">Close</Button></Box>
//       </Dialog>
//     </Container>
//   );
// }
//******************************************************************************** */
import { useEffect, useState, useCallback, useMemo } from "react";
import { IPDCWelcomeMessage } from "../../../components";
import {
  Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
  Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
  FormControl, InputLabel, Select, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TablePagination, Dialog, DialogContent,
  DialogTitle, CircularProgress, Chip, ToggleButton, ToggleButtonGroup
} from "@mui/material";
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  WarningAmber as WarningIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  CompareArrows as CompareIcon,
  AttachMoney as MoneyIcon,
  Assessment as AssessmentIcon,
  Business as BusinessIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  Download as DownloadIcon,
  Close as CloseIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  ShowChart as ShowChartIcon,
  Visibility as VisibilityIcon,
  People as PeopleIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";

// Helper function to normalize currency values
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "birr";
  return mode;
};

// Format number with K, M, B abbreviations for data visualization
const formatNumberWithAbbreviation = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  
  const absNum = Math.abs(num);
  let formattedValue;
  let suffix = '';
  
  if (absNum >= 1e9) {
    formattedValue = (num / 1e9).toFixed(1);
    suffix = 'B';
  } else if (absNum >= 1e6) {
    formattedValue = (num / 1e6).toFixed(1);
    suffix = 'M';
  } else if (absNum >= 1e3) {
    formattedValue = (num / 1e3).toFixed(1);
    suffix = 'K';
  } else {
    formattedValue = num.toFixed(0);
  }
  
  // Remove .0 if it exists
  if (formattedValue.endsWith('.0')) {
    formattedValue = formattedValue.slice(0, -2);
  }
  
  return formattedValue + suffix;
};

const formatNumber = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  return new Intl.NumberFormat('en-US').format(num);
};

const formatCurrency = (amount, paymentMode) => {
  const formatted = formatNumberWithAbbreviation(amount);
  const mode = normalizeCurrency(paymentMode);
  if (mode === "usd") return `$${formatted}`;
  return `${formatted} ETB`;
};

const formatCurrencyUSD = (amount) => {
  return `$${formatNumberWithAbbreviation(amount)}`;
};

const formatCurrencyETB = (amount) => {
  return `${formatNumberWithAbbreviation(amount)} ETB`;
};

const formatPercentage = (value) => {
  const num = toNumber(value);
  if (num === 0) return "0%";
  return `${num.toFixed(1)}%`;
};

const formatDate = (date) => {
  if (!date) return "N/A";
  try {
    return format(new Date(date), 'dd/MM/yyyy');
  } catch {
    return "Invalid Date";
  }
};

// Progress Bar Component - Smaller
const ProgressBarCell = ({ value, label, color }) => {
  const percentage = Math.min(100, Math.max(0, toNumber(value)));
  const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
  
  return (
    <Box sx={{ minWidth: 80 }}>
      <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
            <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
              {formatPercentage(percentage)}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: 5,
              borderRadius: 2.5,
              backgroundColor: '#e0e0e0',
              '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

// Invoice Status Tracker Component - Smaller
const InvoiceStatusTracker = ({ revenueData, arrearsData }) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const [activeCurrency, setActiveCurrency] = useState('usd');
  
  // Calculate USD totals
  const totalInvoicedUSD = revenueData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.amount || 0), 0) %100;
 
  const totalOutstandingUSD = arrearsData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0) % 100;
  
  const totalCollectedUSD = Math.max(0, Math.abs(totalInvoicedUSD + totalOutstandingUSD));
  const paidPercentageUSD = totalInvoicedUSD > 0 ? (totalInvoicedUSD /  totalCollectedUSD) * 100 : 0;

  console.log(totalInvoicedUSD)
  console.log(totalOutstandingUSD)

  const outstandingPercentageUSD = totalInvoicedUSD > 0 ? (totalOutstandingUSD / (totalOutstandingUSD + Math.abs(totalInvoicedUSD))) * 100 : 0;
  
  // Calculate ETB totals
  const totalInvoicedETB = revenueData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.amount || 0), 0);
  
  const totalOutstandingETB = arrearsData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  
  const totalCollectedETB = Math.max(0, Math.abs(totalInvoicedETB - totalOutstandingETB));
  const paidPercentageETB = totalInvoicedETB > 0 ? (totalCollectedETB / totalInvoicedETB) * 100 : 0;
  const outstandingPercentageETB = totalInvoicedETB > 0 ? (totalOutstandingETB / totalInvoicedETB) * 100 : 0;
  
  // Group revenue by month for trend
  const monthlyRevenueUSD = months.map((_, idx) => {
    const monthNum = String(idx + 1).padStart(2, '0');
    return revenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd" && item.month === monthNum)
      .reduce((sum, item) => sum + (item.amount || 0), 0);
  });
  
  const monthlyRevenueETB = months.map((_, idx) => {
    const monthNum = String(idx + 1).padStart(2, '0');
    return revenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr" && item.month === monthNum)
      .reduce((sum, item) => sum + (item.amount || 0), 0);
  });
  
  const monthlyArrearsUSD = months.map((_, idx) => {
    const monthNum = String(idx + 1).padStart(2, '0');
    return arrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd" && item.month === monthNum)
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  });
  
  const monthlyArrearsETB = months.map((_, idx) => {
    const monthNum = String(idx + 1).padStart(2, '0');
    return arrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr" && item.month === monthNum)
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  });
  
  const maxValueUSD = Math.max(...monthlyRevenueUSD, ...monthlyArrearsUSD, 1);
  const maxValueETB = Math.max(...monthlyRevenueETB, ...monthlyArrearsETB, 1);
  
  const chartHeight = 200; // Reduced from 250
  const chartWidth = 400; // Reduced from 480
  const padding = { top: 25, right: 35, bottom: 35, left: 50 };
  
  // Donut Chart Component - Smaller
  const DonutChart = ({ title, collected, outstanding, total, collectedPercent, outstandingPercent, currencySymbol, bgColor }) => {
    const circumference = 2 * Math.PI * 40;
    const collectedDash = (collectedPercent / 100) * circumference;
    const outstandingDash = (outstandingPercent / 100) * circumference;
    
    return (
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 0.5, color: bgColor, fontSize: '0.7rem' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, flexDirection: 'column' }}>
          <Box sx={{ position: 'relative', width: 100, height: 100 }}>
            <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}>
              <circle cx="50" cy="50" r="40" fill="#f5f5f5" stroke="#e0e0e0" strokeWidth="1" />
              <circle 
                cx="50" cy="50" r="40" 
                fill="none" 
                stroke="#4caf50" 
                strokeWidth="12" 
                strokeDasharray={`${collectedDash} ${circumference}`}
                strokeDashoffset="0"
                strokeLinecap="round"
              />
              <circle 
                cx="50" cy="50" r="40" 
                fill="none" 
                stroke="#d32f2f" 
                strokeWidth="12" 
                strokeDasharray={`${outstandingDash} ${circumference}`}
                strokeDashoffset={`-${collectedDash}`}
                strokeLinecap="round"
              />
              <circle cx="50" cy="50" r="30" fill="white" />
              <text x="50" y="46" textAnchor="middle" style={{ fontSize: '10px' }} fill="#333">Total</text>
              <text x="50" y="58" textAnchor="middle" style={{ fontSize: '10px' }} fill="#1976d2">
                {currencySymbol}{formatNumberWithAbbreviation(total)}
              </text>
            </svg>
          </Box>
          
          <Box sx={{ minWidth: 120 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ width: 8, height: 8, bgcolor: '#4caf50', borderRadius: 1 }} />
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mr: 1}}>Collected :  </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                <Typography variant="body2" fontWeight="bold" sx={{ color: '#4caf50', fontSize: '0.8rem' }}>
                  {collectedPercent.toFixed(1)}%
                </Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>
                  ({currencySymbol}{formatNumberWithAbbreviation(collected)})
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ width: 8, height: 8, bgcolor: '#d32f2f', borderRadius: 1 }} />
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mr: 1 }}>
                  Outstanding :  
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                <Typography variant="body2" fontWeight="bold" sx={{ color: '#d32f2f', fontSize: '0.8rem' }}>
                  {outstandingPercent.toFixed(1)}%
                </Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>
                  ({currencySymbol}{formatNumberWithAbbreviation(outstanding)})
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };
  
  // Monthly Trend Chart Component - Smaller
  const MonthlyTrendChart = ({ revenueData, arrearsData, maxValue, currencySymbol, lineColor1, lineColor2 }) => (
    <Box sx={{ width: '100%' }}>
      <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`}>
        {[0, 25, 50, 75, 100].map((percent, idx) => {
          const value = (maxValue * percent) / 100;
          const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
          return (
            <g key={idx}>
              <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="3" />
              <text x={padding.left - 6} y={y} textAnchor="end" fontSize="7" fill="#666">
                {currencySymbol}{formatNumberWithAbbreviation(value)}
              </text>
            </g>
          );
        })}
        
        <polyline points={revenueData.map((value, idx) => {
          const x = padding.left + (idx / (Math.max(revenueData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
          const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
          return `${x},${y}`;
        }).join(' ')} fill="none" stroke={lineColor1} strokeWidth="2" />
        
        <polyline points={arrearsData.map((value, idx) => {
          const x = padding.left + (idx / (Math.max(arrearsData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
          const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
          return `${x},${y}`;
        }).join(' ')} fill="none" stroke={lineColor2} strokeWidth="2" />
        
        {revenueData.map((value, idx) => {
          const x = padding.left + (idx / (Math.max(revenueData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
          const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
          return <circle key={`rev-${idx}`} cx={x} cy={y} r="3" fill={lineColor1} stroke="white" strokeWidth="1.5" />;
        })}
        
        {arrearsData.map((value, idx) => {
          const x = padding.left + (idx / (Math.max(arrearsData.length - 1, 1))) * (chartWidth - padding.left - padding.right);
          const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
          return <circle key={`arr-${idx}`} cx={x} cy={y} r="3" fill={lineColor2} stroke="white" strokeWidth="1.5" />;
        })}
        
        {months.map((month, idx) => {
          const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
          return <text key={idx} x={x} y={chartHeight - padding.bottom + 14} textAnchor="middle" fontSize="7" fontWeight="500">{month}</text>;
        })}
        
        <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
        <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
      </svg>
      
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 20, height: 2, bgcolor: lineColor1 }} />
          <Box sx={{ width: 6, height: 6, bgcolor: lineColor1, borderRadius: '50%' }} />
          <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>Invoiced</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 20, height: 2, bgcolor: lineColor2 }} />
          <Box sx={{ width: 6, height: 6, bgcolor: lineColor2, borderRadius: '50%' }} />
          <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>Outstanding</Typography>
        </Box>
      </Box>
    </Box>
  );
  
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <ToggleButtonGroup
          value={activeCurrency}
          exclusive
          onChange={(e, val) => val && setActiveCurrency(val)}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              borderColor: '#1976d2',
              color: '#1976d2',
              textTransform: 'none',
              px: 2,
              py: 0.5,
              fontSize: '0.7rem',
              '&.Mui-selected': {
                backgroundColor: '#1976d2',
                color: 'white',
              }
            }
          }}
        >
          <ToggleButton value="usd">USD</ToggleButton>
          <ToggleButton value="etb">ETB</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      
      {/* USD View */}
      {activeCurrency === 'usd' && (
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 1.5, overflowX: 'auto', justifyContent: 'center', alignItems: 'center' }}>
            <DonutChart 
              title="Invoice Status (USD)"
              collected={totalCollectedUSD}
              outstanding={totalOutstandingUSD}
              total={totalInvoicedUSD}
              collectedPercent={paidPercentageUSD}
              outstandingPercent={outstandingPercentageUSD}
              currencySymbol="$"
              bgColor="#1976d2"
            />
            
            <Box sx={{ width: 1.5, height: 200, bgcolor: '#e0e0e0', alignSelf: 'center' }} />
            
            <Box sx={{ flex: 1, minWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 1, color: '#1976d2', fontSize: '0.7rem' }}>
                Monthly USD Trend
              </Typography>
              <MonthlyTrendChart 
                revenueData={monthlyRevenueUSD}
                arrearsData={monthlyArrearsUSD}
                maxValue={maxValueUSD}
                currencySymbol="$"
                lineColor1="#1976d2"
                lineColor2="#d32f2f"
              />
            </Box>
          </Box>
          
          <Box sx={{ mt: 1.5, p: 1, bgcolor: '#f5f5f5', borderRadius: 1.5, display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 1 }}>
            <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
              Invoiced:
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="#1976d2" sx={{ fontSize: '0.8rem' }}>
              ${formatNumberWithAbbreviation(totalInvoicedUSD)}
            </Typography>
          </Box>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
              Collected: 
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="#4caf50" sx={{ fontSize: '0.8rem' }}>
              ${formatNumberWithAbbreviation(totalCollectedUSD)}
            </Typography>
          </Box>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
              Outstanding:
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '0.8rem' }}>
              ${formatNumberWithAbbreviation(totalOutstandingUSD)}
            </Typography>
          </Box>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
              Collection Rate
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="#1976d2" sx={{ fontSize: '0.8rem' }}>
              {paidPercentageUSD.toFixed(1)}%
            </Typography>
          </Box>
            </Box>
          </Box>
        </Box>
      )}
      
      {/* ETB View - Similar smaller sizing */}
      {activeCurrency === 'etb' && (
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 1.5, overflowX: 'auto', justifyContent: 'center', alignItems: 'center' }}>
            <DonutChart 
              title="Invoice Status (ETB)"
              collected={totalCollectedETB}
              outstanding={totalOutstandingETB}
              total={totalInvoicedETB}
              collectedPercent={paidPercentageETB}
              outstandingPercent={outstandingPercentageETB}
              currencySymbol=""
              bgColor="#2e7d32"
            />
            
            <Box sx={{ width: 1.5, height: 200, bgcolor: '#e0e0e0', alignSelf: 'center' }} />
            
            <Box sx={{ flex: 1, minWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 1, color: '#2e7d32', fontSize: '0.7rem' }}>
                Monthly ETB Trend
              </Typography>
              <MonthlyTrendChart 
                revenueData={monthlyRevenueETB}
                arrearsData={monthlyArrearsETB}
                maxValue={maxValueETB}
                currencySymbol=""
                lineColor1="#2e7d32"
                lineColor2="#d32f2f"
              />
            </Box>
          </Box>
          
          <Box sx={{ mt: 1.5, p: 1, bgcolor: '#f5f5f5', borderRadius: 1.5, display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 1 }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Invoiced</Typography>
              <Typography variant="body2" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '0.7rem' }}>{formatNumberWithAbbreviation(totalInvoicedETB)} ETB</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Collected</Typography>
              <Typography variant="body2" fontWeight="bold" color="#4caf50" sx={{ fontSize: '0.7rem' }}>{formatNumberWithAbbreviation(totalCollectedETB)} ETB</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Outstanding</Typography>
              <Typography variant="body2" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '0.7rem' }}>{formatNumberWithAbbreviation(totalOutstandingETB)} ETB</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500, fontSize: '0.6rem' }}>Collection Rate</Typography>
              <Typography variant="body2" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '0.7rem' }}>{paidPercentageETB.toFixed(1)}%</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

// Top 5 Customers Pie Chart - Smaller
const TopCustomersPieChart = ({ data, title, subtitle, currencySymbol }) => {
  const total = Object.values(data).reduce((sum, val) => sum + toNumber(val), 0);
  const colors = ['#1976d2', '#2196f3', '#42a5f5', '#64b5f6', '#90caf9', '#e0e0e0'];
  const items = Object.keys(data);
  const displayItems = items.slice(0, 5);
  const top5Total = displayItems.reduce((sum, key) => sum + toNumber(data[key]), 0);
  const otherValue = total - top5Total;
  
  let startAngle = 0;
  const centerX = 60, centerY = 60, radius = 50;
  const svgSize = 120;
  
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5, fontSize: '0.7rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
          <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
            {[...displayItems, ...(otherValue > 0 ? ['Others'] : [])].map((key, idx) => {
              const value = key === 'Others' ? otherValue : toNumber(data[key]);
              const percentage = total > 0 ? (value / total) * 100 : 0;
              const angle = (percentage / 100) * 360;
              const endAngle = startAngle + angle;
              
              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;
              
              const x1 = centerX + radius * Math.cos(startRad);
              const y1 = centerY + radius * Math.sin(startRad);
              const x2 = centerX + radius * Math.cos(endRad);
              const y2 = centerY + radius * Math.sin(endRad);
              
              const largeArcFlag = angle > 180 ? 1 : 0;
              const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
              const slice = <path key={idx} d={pathData} fill={colors[idx % colors.length]} stroke="white" strokeWidth="1" />;
              startAngle = endAngle;
              return slice;
            })}
            <circle cx={centerX} cy={centerY} r="22" fill="white" />
          </svg>
        </Box>
        <Box sx={{ minWidth: 110 }}>
          {displayItems.map((customer, idx) => {
            const value = toNumber(data[customer]);
            return (
              <Box key={customer} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
                <Box sx={{ width: 8, height: 8, bgcolor: colors[idx], borderRadius: 1 }} />
                <Typography variant="caption" sx={{ fontSize: '0.6rem', flex: 1 }}>{customer.length > 12 ? customer.substring(0, 10) + '...' : customer}</Typography>
                <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{currencySymbol}{formatNumberWithAbbreviation(value)}</Typography>
              </Box>
            );
          })}
          {otherValue > 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.3 }}>
              <Box sx={{ width: 8, height: 8, bgcolor: '#e0e0e0', borderRadius: 1 }} />
              <Typography variant="caption" sx={{ fontSize: '0.6rem', flex: 1 }}>Others</Typography>
              <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{currencySymbol}{formatNumberWithAbbreviation(otherValue)}</Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1, fontSize: '0.55rem' }}>{subtitle}</Typography>
    </Box>
  );
};

// Horizontal Bar Chart for Aging Buckets - Smaller
const AgingBucketsChart = ({ arrearsData }) => {
  const buckets = ['0-30 days', '31-60 days', '61-90 days', '90+ days'];
  
  const amounts = buckets.map(bucket => {
    if (bucket === '0-30 days') {
      return arrearsData.filter(item => item.overdue_days > 0 && item.overdue_days <= 30)
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    } else if (bucket === '31-60 days') {
      return arrearsData.filter(item => item.overdue_days > 30 && item.overdue_days <= 60)
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    } else if (bucket === '61-90 days') {
      return arrearsData.filter(item => item.overdue_days > 60 && item.overdue_days <= 90)
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    } else {
      return arrearsData.filter(item => item.overdue_days > 90)
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    }
  });
  
  const maxAmount = Math.max(...amounts, 1);
  
  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2, fontSize: '0.7rem' }}>Aging Buckets by Overdue Amount</Typography>
      {buckets.map((bucket, idx) => {
        const widthPercentage = (amounts[idx] / maxAmount) * 100;
        return (
          <Box key={idx} sx={{ mb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>{bucket}</Typography>
              <Typography variant="caption" sx={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '0.8rem' }}>${formatNumberWithAbbreviation(amounts[idx])}</Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={widthPercentage}
              sx={{
                height: 20,
                borderRadius: 2,
                backgroundColor: '#f5f5f5',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: idx === 0 ? '#ffc107' : idx === 1 ? '#ff9800' : idx === 2 ? '#f44336' : '#d32f2f',
                  borderRadius: 2,
                }
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

// Top 5 Customers Bar Chart - Smaller
const TopCustomersBarChart = ({ data, title, color, currencySymbol }) => {
  const customers = Object.keys(data);
  const maxValue = Math.max(...Object.values(data).map(v => toNumber(v)), 0);
  
  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.9rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.8, minHeight: 200, justifyContent: 'center', flexWrap: 'wrap' }}>
        {customers.map((customer) => {
          const value = toNumber(data[customer]);
          const height = maxValue > 0 ? (value / maxValue) * 140 : 0;
          return (
            <Tooltip key={customer} title={`${customer}: ${currencySymbol}${formatNumberWithAbbreviation(value)}`} arrow>
              <Box sx={{ textAlign: 'center', minWidth: 50 }}>
                <Box sx={{ height: height, width: '35px', bgcolor: color, borderRadius: '3px 3px 0 0', margin: '0 auto', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8, transform: 'translateY(-3px)' } }} />
                <Typography variant="caption" sx={{ mt: 0.3, display: 'block', fontWeight: 'bold', fontSize: '0.8rem' }}>{customer.length > 10 ? customer.substring(0, 8) + '...' : customer}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>{currencySymbol}{formatNumberWithAbbreviation(value)}</Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
};

// Overdue Balance by Collector Pie Chart - Smaller
const CollectorPieChart = ({ arrearsData }) => {
  const collectorMap = {};
  
  arrearsData.forEach(item => {
    const collector = item.collector_name || item.collector || 'Unassigned';
    collectorMap[collector] = (collectorMap[collector] || 0) + (item.outstanding || 0);
  });
  
  const collectors = Object.keys(collectorMap);
  const amounts = Object.values(collectorMap);
  const total = amounts.reduce((sum, val) => sum + val, 0);
  const percentages = amounts.map(amt => total > 0 ? (amt / total) * 100 : 0);
  const colors = ['#1976d2', '#42a5f5', '#64b5f6', '#90caf9', '#bbdefb'];
  
  let startAngle = 0;
  const centerX = 60, centerY = 60, radius = 50;
  const svgSize = 120;
  
  if (collectors.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', p: 2 }}>
        <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.6rem' }}>No collector data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ textAlign: 'center', p: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, fontSize: '0.7rem' }}>Overdue Balance by Collector</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
          <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
            {collectors.map((collector, idx) => {
              const percentage = percentages[idx];
              const angle = (percentage / 100) * 360;
              const endAngle = startAngle + angle;
              
              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;
              
              const x1 = centerX + radius * Math.cos(startRad);
              const y1 = centerY + radius * Math.sin(startRad);
              const x2 = centerX + radius * Math.cos(endRad);
              const y2 = centerY + radius * Math.sin(endRad);
              
              const largeArcFlag = angle > 180 ? 1 : 0;
              const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
              const slice = <path key={idx} d={pathData} fill={colors[idx % colors.length]} stroke="white" strokeWidth="1" />;
              startAngle = endAngle;
              return slice;
            })}
            <circle cx={centerX} cy={centerY} r="22" fill="white" />
          </svg>
        </Box>
        <Box>
          {collectors.map((collector, idx) => (
            <Box key={collector} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
              <Box sx={{ width: 8, height: 8, bgcolor: colors[idx % colors.length], borderRadius: 1 }} />
              <Typography variant="body2" sx={{ fontSize: '0.6rem', minWidth: 70 }}>{collector}</Typography>
              <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.6rem' }}>{percentages[idx].toFixed(0)}%</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default function AccountsReceivableDashboard() {
  // State Management
  const [loading, setLoading] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const [arrearsData, setArrearsData] = useState([]);
  
  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("all");
  const [selectedCollector, setSelectedCollector] = useState("all");
  const [selectedCurrency, setSelectedCurrency] = useState("all");
  
  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  
  // Derived Data from API
  const revenueUSD = useMemo(() => {
    return revenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd")
      .reduce((sum, item) => sum + (item.amount || 0), 0);
  }, [revenueData]);
  
  const revenueETB = useMemo(() => {
    return revenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr")
      .reduce((sum, item) => sum + (item.amount || 0), 0);
  }, [revenueData]);
  
  const arrearsUSD = useMemo(() => {
    return arrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd")
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  }, [arrearsData]);
  
  const arrearsETB = useMemo(() => {
    return arrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr")
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
  }, [arrearsData]);
  
  const percentOverdue = useMemo(() => {
    const totalRevenue = revenueUSD + revenueETB;
    const totalArrears = arrearsUSD + arrearsETB;
    return totalRevenue > 0 ? (totalArrears / totalRevenue) * 100 : 0;
  }, [revenueUSD, revenueETB, arrearsUSD, arrearsETB]);
  
  // Top 5 Customers (from Revenue data)
  const topCustomersBySales = useMemo(() => {
    const customerMap = {};
    revenueData.forEach(item => {
      const customer = item.company_name;
      if (customer && customer !== "N/A") {
        customerMap[customer] = (customerMap[customer] || 0) + (item.amount || 0);
      }
    });
    const sorted = Object.entries(customerMap)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
    return Object.fromEntries(sorted);
  }, [revenueData]);
  
  // Top 5 Customers by Receivables
  const topCustomersByReceivables = useMemo(() => {
    const customerMap = {};
    revenueData
      .filter(item => item.payment_status !== "Completed")
      .forEach(item => {
        const customer = item.company_name;
        if (customer && customer !== "N/A") {
          customerMap[customer] = (customerMap[customer] || 0) + (item.amount || 0);
        }
      });
    const sorted = Object.entries(customerMap)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
    return Object.fromEntries(sorted);
  }, [revenueData]);
  
  // Top 5 Customers by Overdue Receivables
  const topCustomersByOverdue = useMemo(() => {
    const customerMap = {};
    arrearsData.forEach(item => {
      const customer = item.company_name;
      if (customer && customer !== "N/A") {
        customerMap[customer] = (customerMap[customer] || 0) + (item.outstanding || 0);
      }
    });
    const sorted = Object.entries(customerMap)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
    return Object.fromEntries(sorted);
  }, [arrearsData]);
  
  // Customers and Collectors Lists
  const customersList = useMemo(() => {
    const customers = new Set();
    revenueData.forEach(item => {
      if (item.company_name && item.company_name !== "N/A") customers.add(item.company_name);
    });
    arrearsData.forEach(item => {
      if (item.company_name && item.company_name !== "N/A") customers.add(item.company_name);
    });
    return Array.from(customers);
  }, [revenueData, arrearsData]);
  
  const collectorsList = useMemo(() => {
    const collectors = new Set();
    arrearsData.forEach(item => {
      if (item.collector_name && item.collector_name !== "N/A") collectors.add(item.collector_name);
      if (item.collector && item.collector !== "N/A") collectors.add(item.collector);
    });
    return Array.from(collectors);
  }, [arrearsData]);
  
  // Outstanding Invoices from Arrears data
  const outstandingInvoices = useMemo(() => {
    return arrearsData.map((item, index) => ({
      id: item.agreement_id || `ARR-${index}`,
      customer: item.company_name,
      collector: item.collector_name || item.collector || "Unassigned",
      date: item.due_date_formatted || formatDate(item.due_date),
      dueDate: item.due_date_formatted || formatDate(item.due_date),
      amount: item.outstanding || 0,
      outstanding: item.outstanding || 0,
      days: item.overdue_days || 0,
      status: item.status || "Current",
      payment_mode: item.payment_mode
    }));
  }, [arrearsData]);
  
  // Filtered invoices based on search and filters
  const filteredInvoices = useMemo(() => {
    let filtered = [...outstandingInvoices];
    
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.customer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.id?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedCustomer !== "all") {
      filtered = filtered.filter(item => item.customer === selectedCustomer);
    }
    
    if (selectedCollector !== "all") {
      filtered = filtered.filter(item => item.collector === selectedCollector);
    }
    
    if (selectedCurrency !== "all") {
      filtered = filtered.filter(item => normalizeCurrency(item.payment_mode) === selectedCurrency);
    }
    
    return filtered;
  }, [outstandingInvoices, searchTerm, selectedCustomer, selectedCollector, selectedCurrency]);

  // Fetch Revenue Data from API
  useEffect(() => {
    const fetchRevenue = async () => {
      try {
        const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
        console.log("Revenue Response:", resultData);
        
        let dataArray = [];
        if (resultData && Array.isArray(resultData)) {
          dataArray = resultData;
        } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
          dataArray = resultData.data;
        } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
          dataArray = resultData.results;
        } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
          dataArray = resultData.items;
        } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
          dataArray = resultData.records;
        } else if (resultData && typeof resultData === 'object') {
          for (let key in resultData) {
            if (Array.isArray(resultData[key])) {
              dataArray = resultData[key];
              console.log(`Found array in property: ${key}`);
              break;
            }
          }
        }
        
        if (dataArray.length > 0) {
          const formattedData = dataArray.map((item, index) => {
            let revenueAmount = 0;
            
            if (item.payment_amount !== undefined && item.payment_amount !== null) {
              if (typeof item.payment_amount === 'number') {
                revenueAmount = item.payment_amount;
              } else if (typeof item.payment_amount === 'string') {
                const cleaned = item.payment_amount.replace(/,/g, '');
                revenueAmount = parseFloat(cleaned);
                if (isNaN(revenueAmount)) revenueAmount = 0;
              } else {
                revenueAmount = parseFloat(item.payment_amount);
                if (isNaN(revenueAmount)) revenueAmount = 0;
              }
            }
            else if (item.amount !== undefined && item.amount !== null) {
              revenueAmount = parseFloat(item.amount);
              if (isNaN(revenueAmount)) revenueAmount = 0;
            } else if (item.revenue !== undefined && item.revenue !== null) {
              revenueAmount = parseFloat(item.revenue);
              if (isNaN(revenueAmount)) revenueAmount = 0;
            }
            
            let paymentMode = "ETB";
            if (item.payment_mode) {
              paymentMode = item.payment_mode;
            } else if (item.currency) {
              paymentMode = item.currency;
            }
            
            let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
            let month = item.month;
            let year = item.year;
            
            if (transactionDate && !month) {
              try {
                const dateObj = new Date(transactionDate);
                if (!isNaN(dateObj.getTime())) {
                  month = format(dateObj, 'MM');
                  year = format(dateObj, 'yyyy');
                }
              } catch (e) {
                console.warn("Date parsing error:", e);
              }
            }
            
            return {
              id: item.id || item.revenue_id || item.transaction_id || index,
              transaction_id: item.transaction_id || item.id || `TRX-${index}`,
              company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
              park_name: item.park || item.park_name || item.location || "N/A",
              payment_mode: paymentMode,
              amount: revenueAmount,
              formattedAmount: formatCurrency(revenueAmount, paymentMode),
              transaction_date: transactionDate,
              transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
              revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
              payment_status: item.payment_status || item.status || "Completed",
              tenant_name: item.company_name || item.tenant_name || "N/A",
              invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
              description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
              month: month || "01",
              year: year || "2024",
              upin: item.upin || "N/A",
              contact_number: item.contact_number || item.phone || "N/A",
              email: item.email || "N/A"
            };
          });
          
          console.log("Formatted revenue data:", formattedData);
          setRevenueData(formattedData);
        } else {
          console.log("No revenue data received");
          setRevenueData([]);
        }
      } catch (error) {
        console.error("Failed to fetch revenue data:", error);
        setRevenueData([]);
      }
    };
    
    fetchRevenue();
  }, []);

  // Fetch Arrear Data from API
  useEffect(() => {
    const fetchArrear = async () => {
      try {
        const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
        console.log("Arrear Response:", resultData);
        
        if (resultData && Array.isArray(resultData)) {
          const formattedData = resultData.map(item => {
            const overdueDays = item.overdue_date || 0;
            const outstandingAmount = parseFloat(item.outstanding) || 0;
            const paymentMode = item.payment_mode || "ETB";
            
            let year = "2024";
            let month = "01";
            if (item.due_date) {
              try {
                const dateObj = new Date(item.due_date);
                if (!isNaN(dateObj.getTime())) {
                  year = format(dateObj, 'yyyy');
                  month = format(dateObj, 'MM');
                }
              } catch (e) {}
            }
            
            return {
              id: item.agreement_id,
              agreement_id: item.agreement_id,
              company_name: item.company_name || "N/A",
              park_name: item.park || "N/A",
              payment_mode: paymentMode,
              outstanding: outstandingAmount,
              formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
              due_date: item.due_date,
              due_date_formatted: formatDate(item.due_date),
              overdue_days: overdueDays,
              status: overdueDays >= 90 ? "Critical" : overdueDays >= 60 ? "Severe" : overdueDays >= 30 ? "Moderate" : overdueDays >= 1 ? "Mild" : "Current",
              collector_name: item.collector_name || item.collector,
              collector: item.collector || item.collector_name,
              tenant_name: item.company_name || "N/A",
              amount_due: outstandingAmount,
              amount_paid: 0,
              balance: outstandingAmount,
              days_overdue: overdueDays,
              description: `Arrears for ${item.company_name}`,
              upin: item.upin || "N/A",
              contact_number: item.contact_number || "N/A",
              email: item.email || "N/A",
              month: month,
              year: year
            };
          });
          
          console.log("Formatted arrears data:", formattedData);
          setArrearsData(formattedData);
        } else {
          console.log("No arrears data received");
          setArrearsData([]);
        }
      } catch (error) {
        console.error("Failed to fetch arrears data:", error);
        setArrearsData([]);
      }
    };
    
    fetchArrear();
  }, []);

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCustomer("all");
    setSelectedCollector("all");
    setSelectedCurrency("all");
  };

  const handleExportCSV = () => {
    const headers = ['Invoice #', 'Customer', 'Collector', 'Due Date', 'Days Overdue', 'Amount', 'Status'];
    const csvData = filteredInvoices.map(item => [
      item.id,
      item.customer,
      item.collector,
      item.dueDate,
      item.days,
      formatCurrency(item.amount, item.payment_mode),
      item.status
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `accounts_receivable_${format(new Date(), 'yyyyMMdd')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getCurrentPageData = () => {
    return filteredInvoices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  };

  const isLoading = revenueData.length === 0 && arrearsData.length === 0;

  return (
    <Container maxWidth="xl" sx={{ bgcolor: '#f4f9ff', width: '98%', mx: '1%', py: 1 }}>
      <Grid container spacing={1.5}>
      <Box sx={{ color: 'white', py: 2, px: 3 }}>
        <Container maxWidth="xl">
          <Box>
            <Grid item xs={12} md={12}>
              <IPDCWelcomeMessage messageTitle="Finance Department" />
            </Grid>
          </Box>
        </Container>
      </Box>
        {/* Header */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 0.5, fontSize: '1.1rem' }}>
            Accounts Receivable Dashboard
          </Typography>
        </Grid>
        
        {/* Summary Cards Row - Smaller */}
        <Grid item xs={12}>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Revenue (USD)</Typography>
                  <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '1rem' }}>{formatCurrencyUSD(revenueUSD)}</Typography>
                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Total Revenue in USD</Typography>
                <Divider sx={{ my: 0.5 }} />
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Revenue (ETB)</Typography>
                  <MoneyIcon sx={{ color: '#2e7d32', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" fontWeight="bold" color="#2e7d32" sx={{ fontSize: '1rem' }}>{formatCurrencyETB(revenueETB)}</Typography>
                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '1.2rem' }}>Total revenue in ETB</Typography>
                <Divider sx={{ my: 0.5 }} />
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Arrears (USD)</Typography>
                  <WarningIcon sx={{ color: '#d32f2f', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '1rem' }}>{formatCurrencyUSD(arrearsUSD)}</Typography>
                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Outstanding in USD</Typography>
                <Divider sx={{ my: 0.5 }} />
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: 1.5, bgcolor: '#e8f5e9', height: '100%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Arrears (ETB)</Typography>
                  <AccountBalanceIcon sx={{ color: '#d32f2f', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" fontWeight="bold" color="#d32f2f" sx={{ fontSize: '1rem' }}>{formatCurrencyETB(arrearsETB)}</Typography>
                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.8rem' }}>Outstanding in ETB</Typography>
                <Divider sx={{ my: 0.5 }} />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        
        {/* Chart 1: Invoice Status Tracker - Smaller card */}
        <Grid item xs={12}>
          <Card sx={{ bgcolor: '#fafafa' }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Invoice Status Tracker</Typography>
                <BarChartIcon sx={{ color: '#666', fontSize: 18 }} />
              </Box>
              <Divider sx={{ mb: 1 }} />
              <InvoiceStatusTracker revenueData={revenueData} arrearsData={arrearsData} />
            </CardContent>
          </Card>
        </Grid>

        {/* Chart 2: Aging Buckets */}
        <Grid item xs={12} md={6}>
          <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Aging Buckets by Overdue Amount</Typography>
                <BarChartIcon sx={{ color: '#d32f2f', fontSize: 18 }} />
              </Box>
              <Divider sx={{ mb: 1 }} />
              <AgingBucketsChart arrearsData={arrearsData} />
            </CardContent>
          </Card>
        </Grid>
        
        {/* Chart 3: Top 5 Customers by Overdue Receivables */}
        <Grid item xs={12} md={6}>
          <Card sx={{ bgcolor: '#fafafa', height: '100%' }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a237e', fontSize: '1.2rem' }}>Top 5 Customers by Overdue</Typography>
                <WarningIcon sx={{ color: '#d32f2f', fontSize: 18 }} />
              </Box>
              <Divider sx={{ mb: 1 }} />
              <TopCustomersBarChart 
                data={topCustomersByOverdue}
                title="Top 5 Customers by Overdue Receivables"
                color="#d32f2f"
                currencySymbol="$"
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      {/* Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Invoice Details</Typography>
            <IconButton onClick={() => setOpenDetailsDialog(false)}><CloseIcon /></IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {selectedItem && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Invoice #:</Typography><Typography>{selectedItem.id}</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Customer:</Typography><Typography>{selectedItem.customer}</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Collector:</Typography><Typography>{selectedItem.collector}</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Due Date:</Typography><Typography>{selectedItem.dueDate}</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Days Overdue:</Typography><Typography>{selectedItem.days} days</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Outstanding Amount:</Typography><Typography sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{formatCurrency(selectedItem.amount, selectedItem.payment_mode)}</Typography></Grid>
                <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Status:</Typography><Chip label={selectedItem.status} size="small" color={selectedItem.status === 'Critical' ? 'error' : (selectedItem.status === 'Severe' ? 'warning' : 'info')} /></Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}><Button onClick={() => setOpenDetailsDialog(false)} variant="outlined">Close</Button></Box>
      </Dialog>
    </Container>
  );
}